import type { AxiosInstance } from "axios";

export const config = {
  health: {
    version: () => ({
      url: `/api/health/version`,
      method: "get",
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    health: {
      version: () =>
        apiAxios.request<{ version: string }>(config.health.version()),
    },
  };
};
